import { atom } from "jotai";

/**
 * Selected accessorial ids for the AutoDispatchGrid's accessorials filter
 * cell. Lifted out of Kendo's composite filter descriptor on purpose:
 * Kendo's `filterBy` chokes on array-of-objects fields, so the grid applies
 * this filter itself and Kendo never sees the selection.
 */
export const accessorialsFilterIdsAtom = atom<number[]>([]);
